var map = {
	"./commercial/0.jpg": 34,
	"./commercial/1.jpg": 35,
	"./commercial/2.jpg": 36,
	"./commercial/3.jpg": 37,
	"./commercial/4.jpg": 38,
	"./food/0.jpg": 39,
	"./food/1.jpg": 40,
	"./food/2.jpg": 41,
	"./food/3.jpg": 42,
	"./food/4.jpg": 43,
	"./landscape/0.jpg": 44,
	"./landscape/1.jpg": 45,
	"./landscape/2.jpg": 46,
	"./landscape/3.jpg": 47,
	"./landscape/4.jpg": 48,
	"./portraits/0.jpg": 49,
	"./portraits/1.jpg": 50,
	"./portraits/2.jpg": 51,
	"./portraits/3.jpg": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;